export default __webpack_public_path__ + "static/media/snow-3-day.d2aef6b8.svg";